import React, { useEffect } from 'react'
import { Transforms } from 'vendor/slate'
import { ReactEditor, useReadOnly } from 'vendor/slate-react'
import styled, { useTheme } from 'styled-components'
import Select from 'react-select'
import { API_METHOD_TYPES } from 'cg/components/documents/editor/slate/types'
import { getSelectTheme } from 'Shared/theme'

const ApiMethod = ({ attributes, children, element, editor }) => {
  const readOnly = useReadOnly()
  const { method } = element
  const path = ReactEditor.findPath(editor, element)

  const options = []
  const theme = useTheme()
  useEffect(() => {
    Object.keys(API_METHOD_TYPES).forEach(key => {
      options.push({ label: key, value: API_METHOD_TYPES[key] })
    })
  }, [options])

  const onChange = option => {
    const { value } = option

    Transforms.setNodes(editor, { method: value }, { at: path })
  }

  return (
    <Method {...attributes}>
      <div contentEditable={false}>
        <Select
          styles={SelectStyles({ readOnly, background: method.color, theme })}
          menuPlacement="auto"
          theme={props => ({
            ...props,
            colors: {
              ...props.colors,
              ...getSelectTheme(theme.id)
            },
            borderRadius: 3,
            spacing: {
              controlHeight: 25,
              baseUnit: 1,
              menuGutter: 6
            }
          })}
          getOptionLabel={option => option.label}
          getOptionValue={option => option.value}
          isDisabled={readOnly}
          isSearchable={false}
          value={{ label: method.label, value: API_METHOD_TYPES[method.label] }}
          onChange={onChange}
          options={options}
        />
      </div>
    </Method>
  )
}

export default ApiMethod

const SelectStyles = props => ({
  container: (provided, state) => ({
    ...provided
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '13px',
    textTransform: 'uppercase',
    padding: '5px 8px'
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    width: '20px',
    display: props.readOnly ? 'none' : 'flex',
    cursor: 'pointer',
    padding: '0px 4px 0px 0px',
    color: 'hsl(0,0%,93%) !important'
  }),
  indicatorSeparator: provided => ({
    ...provided,
    display: 'none'
  }),
  control: (provided, state) => ({
    ...provided,
    width: '85px',
    fontSize: '13px',
    background: `${props.background}`,
    border: '0px',
    borderRadius: '3px',
    boxShadow: 'none !important',
    padding: '0px'
  }),
  menu: (provided, state) => ({
    ...provided,
    boxShadow: getSelectTheme(props.theme.id).boxShadow,
    border: `1px solid ${getSelectTheme(props.theme.id).borderColor}`,
    zIndex: 102,
    fontSize: '13px'
  }),
  singleValue: (provided, state) => ({
    ...provided,
    display: 'flex',
    transform: 'none',
    alignItems: 'center',
    top: '0%',
    height: '100%',
    justifyContent: 'center',
    fontWeight: '500',
    width: '100%',
    color: 'hsl(0,0%,100%)',
    textTransform: 'uppercase'
  })
})

const Method = styled.div`
  margin-right: 10px;
`
